import React, { useState } from 'react';
import axios from 'axios';

const CorporatePlantRentalForm = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    fullName: '',
    email: '',
    phone: '',
    officeAddress: '',
    typeOfPlants: '',
    numberOfPlants: '',
    maintenanceRequired: '',
    preferredStartDate: '',
    message: ''
  });

  const API_URL = process.env.REACT_APP_API_URL;

  const plantOptions = [
    "Bonsai", "Succulent", "Cactus", "Flowering",
    "Indoor Plants", "Outdoor Plants", "Planters",
    "Creepers", "Air Purifying Plants", "Flowering Plants", "Rental"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const { email, phone } = formData;
    if (!email.endsWith('@gmail.com')) {
      alert("Email must be a Gmail address.");
      return false;
    }
    if (!/^\d{10}$/.test(phone)) {
      alert("Phone number must be exactly 10 digits.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const res = await axios.post(`${API_URL}/api/corporate-enquiries/enquire`, formData);
      if (res.status === 200 || res.status === 201) {
        alert('Form submitted successfully');
        setFormData({
          companyName: '',
          fullName: '',
          email: '',
          phone: '',
          officeAddress: '',
          typeOfPlants: '',
          numberOfPlants: '',
          maintenanceRequired: '',
          preferredStartDate: '',
          message: ''
        });
      } else {
        alert('Failed to submit form');
      }
    } catch (error) {
      alert('Error submitting form');
      console.error(error);
    }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-8 shadow-lg rounded-2xl mt-6">
      <h2 className="text-2xl font-bold mb-6 text-green-700">Corporate Plant Rental Form</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {[
          ['Company Name', 'companyName'],
          ['Full Name', 'fullName'],
          ['Email', 'email', 'email'],
          ['Phone Number', 'phone', 'tel'],
          ['Office Address', 'officeAddress']
        ].map(([label, name, type = 'text']) => (
          <div key={name}>
            <label className="block font-semibold mb-1">{label}</label>
            <input
              type={type}
              name={name}
              value={formData[name]}
              onChange={handleChange}
              required
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>
        ))}

        <div>
          <label className="block font-semibold mb-1">Type of Plants</label>
          <select
            name="typeOfPlants"
            value={formData.typeOfPlants}
            onChange={handleChange}
            required
            className="w-full p-2 border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <option value="">-- Select Plant Type --</option>
            {plantOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block font-semibold mb-1">Number of Plants</label>
          <input
            type="number"
            name="numberOfPlants"
            value={formData.numberOfPlants}
            onChange={handleChange}
            min="1"
            required
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          />
        </div>

        <div>
          <label className="block font-semibold mb-1">Maintenance Required</label>
          <select
            name="maintenanceRequired"
            value={formData.maintenanceRequired}
            onChange={handleChange}
            required
            className="w-full p-2 border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <option value="">-- Select Option --</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        <div>
          <label className="block font-semibold mb-1">Preferred Start Date</label>
          <input
            type="date"
            name="preferredStartDate"
            value={formData.preferredStartDate}
            onChange={handleChange}
            required
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          />
        </div>

        <div>
          <label className="block font-semibold mb-1">Additional Message (Optional)</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          ></textarea>
        </div>

        <div>
          <button
            type="submit"
            className="w-full bg-green-600 text-white p-2 rounded-lg hover:bg-green-700 transition duration-200"
          >
            Submit Request
          </button>
        </div>
      </form>
    </div>
  );
};

export default CorporatePlantRentalForm;
